import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { PageHeader } from "ui/components/main-layout/PageHeader"
import { PAGE_HEADER_HEIGHT_IN_REM } from "ui/model"
import { MyReportsList } from "./MyReportsList"

export const MyReportsPage = React.memo(() => (
  <FlexBox jc="start" fullWidth fullHeight vertical>
    <PageHeader title={translate("reports.my.title")} />
    <FlexBox ai="start" vertical fullWidth fullHeight={PAGE_HEADER_HEIGHT_IN_REM} gap sx={{ p: "1rem" }}>
      <Typography
        sx={{
          fontSize: "1.2rem",
          fontWeight: 500,
          color: theme => theme.palette.text.primary2
        }}>
        {translate("reports.list.title")}
      </Typography>
      <MyReportsList />
    </FlexBox>
  </FlexBox>
))
